import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
import { authQueryKeys as r } from "@maat/store-auth";
//#region src/profile/useMfaMutations.ts
var i = () => e({ mutationFn: n.initiateMfa }), a = () => {
	let i = t();
	return e({
		mutationFn: n.verifyMfa,
		onSuccess: () => i.invalidateQueries({ queryKey: r.me() })
	});
}, o = () => {
	let i = t();
	return e({
		mutationFn: n.disableMfa,
		onSuccess: () => i.invalidateQueries({ queryKey: r.me() })
	});
};
//#endregion
export { o as useDisableMfaMutation, i as useInitiateMfaMutation, a as useVerifyMfaMutation };
